import { render } from "./activityDetail.vue?vue&type=template&id=51f29187&scoped=true"
import script from "./activityDetail.vue?vue&type=script&lang=js"
export * from "./activityDetail.vue?vue&type=script&lang=js"

import "./activityDetail.vue?vue&type=style&index=0&id=51f29187&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f29187"]])

export default __exports__